import { useEffect, useRef, useState } from 'react';
import { ChatBubble, TypingBubble } from '@/shared/ChatBubble.jsx';

// "Try the assistant" — tapping a chip appends the prompt and a canned AI
// reply to the thread, with a brief typing indicator in between.
export default function LiveDemo({ t }) {
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState(false);
  const bodyRef = useRef(null);
  const timers = useRef([]);

  // Keep the thread scrolled to the latest message.
  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [messages, typing]);

  useEffect(() => () => timers.current.forEach(clearTimeout), []);

  // Switching language mid-demo would leave the answers in two languages.
  useEffect(() => {
    setMessages([]);
    setTyping(false);
  }, [t]);

  const askAI = (chip) => {
    setMessages((m) => [...m, { from: 'me', text: chip.label }]);
    setTyping(true);
    const id = setTimeout(() => {
      setMessages((m) => [...m, { from: 'ai', text: chip.answer }]);
      setTyping(false);
    }, 1500);
    timers.current.push(id);
  };

  return (
    <section id="demo" className="demo">
      <div className="container">
        <div className="reveal sec-head" style={{ marginBottom: 48 }}>
          <div className="eyebrow">{t.eyebrow}</div>
          <h2>{t.title}</h2>
          <p>{t.lead}</p>
        </div>

        <div className="reveal demo-wrap">
          <div className="demo-glow" />
          <div className="demo-card">
            <div className="demo-head">
              <div className="ico">✦</div>
              <div style={{ flex: 1 }}>
                <div className="title">{t.assistant}</div>
                <div className="sub">{t.builtIn}</div>
              </div>
            </div>

            <div className="demo-body" ref={bodyRef}>
              {messages.map((m, idx) => (
                <ChatBubble key={idx} from={m.from} text={m.text} />
              ))}
              {typing && <TypingBubble variant="ai" />}
            </div>

            <div className="demo-chips">
              {t.chips.map((c) => (
                <button type="button" className="chip" key={c.label} onClick={() => askAI(c)}>
                  {c.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
